export default __webpack_public_path__ + "static/media/brokrete.png.webp";